<template>
    <v-layout column class="manage-geo-zone-container">             
            <!-- legenda corner left -------------------------------------------------------------------------------------------->
            <div class="quick-map-config" :style="boxWidth" v-if="!newMode && !assetMode">
                <div class="quick-map-top-buttons">
                    <!-- <dd-tooltip text="Toon alle geozones"> -->
                        <v-btn fab dark class="mini-button" color="accent" @click="showTypeFilters=true;loadTypeFilters()">
                            <v-icon dark size="18">list</v-icon>
                        </v-btn>            
                    <!-- </dd-tooltip> -->
                    <!-- <dd-tooltip text="Wissel kaart / satteliet"> -->
                        <v-btn fab dark class="mini-button" color="accent" @click="toggleMapType()">
                            <v-icon dark size="18">layers</v-icon>
                        </v-btn>
                    <!-- </dd-tooltip> -->
                </div>
                <v-layout column pl-4 >
                    <v-flex class="quick-map-form">
                        <v-flex style="color:white; cursor:pointer;" d-flex row justify-start xs12 @click="showTypeFilters=!showTypeFilters">
                            <v-flex sm1>
                                <i v-if="showTypeFilters" class="fas fa-angle-down"></i>                            
                                <i v-if="!showTypeFilters" class="fas fa-angle-up"></i>                                
                            </v-flex>                                                        
                            <v-flex v-if="showTypeFilters">Verberg POI type filters</v-flex>
                            <v-flex v-if="!showTypeFilters">Toon POI type filters</v-flex>
                        </v-flex>
                        <v-flex  v-show="showTypeFilters">
                            <v-layout column>
                                <v-flex sm12 d-flex row v-for="zoneType in geoZoneTypes" :key="zoneType.id" justify-space-between align-center> 
                                    <v-checkbox                                                                    
                                    :label="zoneType.name"
                                    v-model="zoneTypeFilters[zoneType.id]"
                                    dark
                                    dense                            
                                    ></v-checkbox>               
                                    <v-flex sm2>
                                        <div class="zone-type-color-box" :style="`background-color:${zoneColor(zoneType.id)}`"></div>
                                    </v-flex>                             
                                </v-flex>                            
                            </v-layout>
                        </v-flex>
                    </v-flex>                    
                </v-layout>      
            </div>    
    <!---------------------------------------------------------------------------------------------------------------------->             
        <v-layout style="background-color:#3E5871;">
            <top-info-panel :animated="false" v-if="!assetMode">
                <v-flex xs12 md12 lg6 xl5 px-2 slot="content" >
                    <h4>Point of interest beheren</h4>
                    <p>Op de kaart kunt u uw eigen point of interests aanmaken en beheren. Deze kunnen gebruikt worden voor het registreren van events, rapportages en meer.</p>                    
                </v-flex>
            </top-info-panel>       
            <v-btn fab dark  color="accent" class="hover-top-right" @click="extraFieldConfigDialog = !extraFieldConfigDialog">
                <v-icon  class="fas fa-tasks"  dark></v-icon>
            </v-btn>                    
            <v-btn fab dark  color="accent" class="hover-top-right" @click="toggleSearchDrawer()">
                <v-icon v-if="!showSearchDrawer" dark>search</v-icon>
                <v-icon v-if="showSearchDrawer" class="fas fa-times" dark></v-icon>
            </v-btn>                            
        </v-layout>     
        <v-layout wrap px-0 align-center justify-center class="inset">                                             
            <div class="fs-map-container" >                
                <l-map
                    @update:zoom="zoomUpdate" 
                    ref="map"
                    :bounds="bounds"
                    :zoom="zoom"
                    :center="mapCenter"
                    :options="mapOptions"
                    style="min-height:300px;"
                    @click="mapClicked"
                    >
                    <!-- <l-marker v-if="marker" :lat-lng="marker" :icon="locationIcon"></l-marker> -->
                    <l-tilelayer :url="url" :attribution="attribution"></l-tilelayer>          
                    <l-group >
                        <l-polyline v-if="editPolyPoints.length > 0"
                            :lat-lngs="editPolyPoints"
                            :color="editPolyPointsColor">
                        </l-polyline>
                        <l-marker 
                            v-for="(point,i) in editPolyPoints" 
                            :key="`edit_${i}`"
                            :lat-lng="marker(point.lat,point.lng)"
                            :icon="icon(editPolyPointsColor)"
                            draggable
                            @dragend="markerDragged($event, i)"
                        ></l-marker>
                    </l-group>
                    <l-group v-if="geoZonesComputed.length > 0 && !newMode"> 
                        <l-marker
                         v-for="zone of zoneMarkers"                        
                        :lat-lng="determineZoneCenter(zone)"                         
                        :key="zone.id"
                        :icon="zonePositionIcon(zone)"
                        @click="centerOrOpenGeozone(zone)"
                        >          
                            <l-tooltip>                                                      
                                <i class="fal fa-search-plus"></i>       
                                {{zone.name}}                                
                            </l-tooltip>                        
                        </l-marker>
                    </l-group>                    
                    <l-group >
                        <l-polygon 
                            v-for="zone of geoZonesComputed"
                            :key="zone.id"
                            :color="zoneColor(zone.geoZoneType.id)"
                            :fillColor="zoneColor(zone.geoZoneType.id)"
                            :lat-lngs="zoneCoordinates(zone)"  
                            @click="editGeozone(zone)"                                
                        >
                            <l-tooltip v-show="!newMode">                                
                                <div style="width:300px;">
                                    <div >
                                        <div class="dd-label">Naam</div>
                                        <div class="dd-value">{{zone.name}}</div>
                                    </div>
                                    
                                    <div>
                                        <div class="dd-label">Oppervlakte</div>
                                        <div class="dd-value">{{geoJsonSquareMeasureHumanReadable(zone.squareMeters)}}</div>
                                    </div>
                                    <div>
                                        <div class="dd-label">Omtrek</div>
                                        <div class="dd-value">{{geojsonLineDistanceHumanReadable(zone.perimeterMeters)}}</div>
                                    </div>
                                    <div xs12 lg12>
                                        <div class="dd-label">Opmerkingen</div>
                                        <div class="dd-value">{{zone.description}}</div>
                                    </div>                                        
                                </div>                                
                            </l-tooltip>                         
                        </l-polygon>
                    </l-group>                
                </l-map>                       
            </div>
             <transition name="geozones"
                enter-active-class="fadeInLeft"
                leave-active-class="fadeOutRight"
                mode="out-in">
                    <div class="zone-list-button">
                        <v-btn fab dark  color="accent"  @click="showList = !showList" v-show="!showList">
                            <v-icon dark>search</v-icon>
                        </v-btn>                  
                    </div>                    
            </transition>
            <div :class="`geozone-new-button ${showButtonAssetMode}`" ><v-btn class="accent" v-if="!newMode && !editMode" @click="startNewGeoZone()">Nieuwe POI maken</v-btn></div>
            <div :class="`geozone-new-button ${showButtonAssetMode}`" ><v-btn class="accent" v-if="newMode || editMode" @click="cancelNewGeoZone()">POI {{editGeoZoneMode}} annuleren</v-btn></div>
            <div :class="`geozone-save-button  ${showButtonAssetMode}`" ><v-btn class="success" v-if="newMode || editMode" @click="saveNewGeoZone()" :disabled="editPolyPoints.length < 3">POI opslaan</v-btn></div>
            <div :class="`geozone-edit-message ${showBarAssetMode} accent white--text px-2 py-2`" v-if="newMode || editMode"> POI bewerken aan </div>    
            
                <transition name="drawerup"
                    enter-active-class="animated slideInUp faster"
                    leave-active-class="animated slideOutDown faster"
                    mode="in-out">           
                    <v-flex class="bottom-drawer dd-size-medium" v-if="showSearchDrawer">
                        <v-layout>
                            <v-flex>
                                <search-geo-zone @showGeoZoneOnMap="centerGeozone" @itemSelected="openEditScreen"></search-geo-zone>
                            </v-flex>
                        </v-layout>               
                    </v-flex>
                </transition>  
            </v-layout>            
            <save-geo-zone v-if="showSaveGeoZone" 
                           :asset="asset"
                           :polyPoints="editPolyPoints" 
                           :color="editPolyPointsColor" 
                           :geoZone="selectedGeoZone" 
                           @geoZoneSaved="geoZoneIsSaved()" 
                           @geoZoneDeleted="geoZoneIsDeleted()" 
                           @geoZoneCanceled="closeSaveGeoZone()"
                           @eventSavedOnGeoZone="loadGeoZones()"
                           @editGeoZoneOnMap="mutateGeoZone()"
                           @openPoiWizard="openPoiWizard">
             </save-geo-zone>                
             <v-dialog v-model="deleteDialog" max-width="500px" v-if="deleteDialog && selectedGeoZone">
                <v-card>
                <v-card-title class="red white--text">
                    POI verwijderen
                </v-card-title>
                <v-card-text>                    
                    Weet u zeker dat u <strong>{{selectedGeoZone.name}}</strong> wilt verwijderen?
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" flat @click="deleteDialog=false;selectedGeoZone=null">Annuleren</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="deleteGeoZone(selectedGeoZone)">Verwijderen</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog  persistent v-model="connectPoiDialog" max-width="500px" v-if="connectPoiDialog">     
                <v-card>
                    <v-card-title :class="`modal-title-bar`" >
                        <h4>Asset koppelen aan POI: {{connectPoiDialog.name}}</h4>
                        <v-spacer></v-spacer>
                        <i class="fas fa-times fa-2x" style="cursor:pointer;" @click="closePoiWizard()"></i>                                
                    </v-card-title>                        
                </v-card>       
                <poi-wizard mode="assetGroup" :geoZone="poiWizardGeoZone" @close="closePoiWizard()" @isSaved="closePoiWizard()"></poi-wizard>
            </v-dialog>    
            <v-dialog  persistent v-model="extraFieldConfigDialog" max-width="800px" v-if="extraFieldConfigDialog">     
                <v-flex  style="background-color:white;">
                    <v-card>
                        <v-card-title :class="`modal-title-bar`" >
                            <h4>Extra velden instellen voor point of interests</h4>
                            <v-spacer></v-spacer>
                            <i class="fas fa-times fa-2x" style="cursor:pointer;" @click="closeCustomDialog()"></i>                                
                        </v-card-title>                        
                    </v-card>     
                    <v-flex pa-4>
                        <poi-custom-field-configurator @canceled="closeCustomDialog()" :geoZone="poiWizardGeoZone" @close="closeCustomDialog()" @isSaved="closeCustomDialog()"></poi-custom-field-configurator>
                    </v-flex>  
                </v-flex>          
            </v-dialog>                                              
        </v-layout>        
    </v-layout>
</template>
<script>
    import Vue from 'vue'
    import { mapGetters } from 'vuex'
    import * as types from "../../store/types"
    import MapMixin from '../../plugins/mixins/MapMixin'
    import ColorMixin from '../../plugins/mixins/ColorMixin'
    import TopInfoPanel from '../../components/global/TopInfoPanel'
    import SaveGeoZone from '../../components/map/SaveGeoZone'
    import VWidget from '../../components/global/VWidget'    
    import DdTooltip from '../../components/global/DdTooltip'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';    
    import PoiWizard from '../../components/geozone/PoiWizard'
    import PoiCustomFieldConfigurator from '../../components/geozone/PoiCustomFieldConfigurator'    
    import SearchGeoZone from '../../components/geozone/SearchGeoZone'
    import ColorHash from 'color-hash';    

    export default {
        props: {
            asset: {
                type: Object
            }
        },
        components:{
            PoiWizard,
            VuePerfectScrollbar,
            TopInfoPanel,
            SaveGeoZone,
            VWidget,  
            DdTooltip,
            SearchGeoZone,
            PoiCustomFieldConfigurator         
        },
        mixins:[ MapMixin, ColorMixin ],
        data(){
            return {     
                showSearchDrawer:false,
                poiWizardGeoZone:null, 
                connectPoiDialog:false,
                extraFieldConfigDialog:false,
                zoneTypeFilters:{},
                showTypeFilters:false,
                mapType:"",          
                newMode: false,
                editMode: false,
                editPolyPoints: [],
                editPolyPointsColor: 'green',
                showSaveGeoZone: false,
                showList: true,
                searchTerm: '',
                deleteDialog:false,
                selectedGeoZone: null,
                scrollSettings: {
                    maxScrollbarLength: 160
                },
                bounds:null                           
            }
        },
        computed:{
            ...mapGetters({
                geoZones: types.GEO_ZONES,                
                geoZoneTypes: types.GEO_ZONE_TYPES,
                mainMenuShown: types.MAIN_MENU_SHOWN,                       
            }),
            zoneMarkers(){
                if(!this.geoZones || this.zoom > 11)
                    return []

                return this.geoZonesComputed
            },
            boxWidth(){            
                return this.mainMenuShown.show ? "margin-left:250px;" : "margin-left:-10px;"
            },
            editGeoZoneMode(){
                return this.editMode ? "wijzigen" : "maken"
            },
            assetMode(){
                return this.asset ? true : false
            },
            showButtonAssetMode(){
                return this.assetMode ? "asset-mode-button" : ""
            },
            showBarAssetMode(){
                return this.assetMode ? "asset-mode-bar" : ""
            },
            geoZonesFiltered(){      
                if(!this.geoZones)  
                    return []
                              
                return this.geoZones.filter((zone) => {        
                   if(zone.geoZoneType)
                      return this.zoneTypeFilters[zone.geoZoneType.id]
                })                                           
            },
            geoZonesComputed(){
                let result = []
                let searchTerm = this.searchTerm
                if(searchTerm != '' && this.geoZones.length > 0){
                    result = this.geoZonesFiltered.filter((ele) => {
                        return (
                            (ele.name && ele.name.toLowerCase().includes(searchTerm.toLowerCase())) || 
                            (ele.description && ele.description.toLowerCase().includes(searchTerm.toLowerCase()))
                        )
                    })
                }
                else
                    result = this.geoZonesFiltered;
            
                return result.sort((a, b) => {
                    if(a.squareMeters > b.squareMeters){
                        return -1
                    }
                    return 1
                })      
            },
            searchHint(){
                
                let oneActive = false;

                for(let i in this.zoneTypeFilters){
                    if(this.zoneTypeFilters[i])
                        oneActive = true;
                }
                return !oneActive ?  "<label style='color:red;'>Geen zones zichtbaar omdat er te weinig geozonetypen actief zijn</label>" : "";
            },          
        },
        methods:{     
            zoomUpdate(nv){                
                this.zoom = nv  
            },            
            toggleSearchDrawer(){
                if(this.showSearchDrawer)
                    this.closeDrawer()
                else
                    this.showSearchDrawer=true
            },
            closeDrawer(){
                // always reload all geozones on close (to remove filter used in search)
                if(this.showSearchDrawer){
                    this.loadGeoZones();
                    this.showSearchDrawer=false
                }
            },
            openEditScreen(zone){
                this.closeDrawer()
                this.centerGeozone(zone)
                this.editGeozone(zone)
            },
            openPoiWizard(geoZone){
                this.closeSaveGeoZone()
                this.poiWizardGeoZone   = geoZone
                this.connectPoiDialog = true
            },  
            closePoiWizard(){
                this.poiGeoZone   = null
                this.connectPoiDialog = false
            },
            zoneColor(zoneTypeId){
                let colorHash = new ColorHash({hue: {min: 220, max: 270}});                
                return colorHash.hex(zoneTypeId);    
            },
            toggleMapType(){
                this.mapType = (this.mapType == 'default') ? 'satelite' : 'default';

                if(this.mapType == 'satelite')
                    this.useSatMap()
                else 
                    this.useDefaultMap()
            },
            getEventName(eventType, zone){
                
                if(eventType == 'enter')
                    return (zone.geoZoneEvent && zone.geoZoneEvent.enterEvent) ? zone.geoZoneEvent.enterEvent.name : "Geen"
                if(eventType == 'exit')
                    return (zone.geoZoneEvent && zone.geoZoneEvent.exitEvent) ? zone.geoZoneEvent.exitEvent.name : "Geen"
            },
            closeSaveGeoZone(){
                this.editPolyPoints=[];
                this.selectedGeoZone=null;
                this.showSaveGeoZone=false;
                this.editMode=false;
            }, 
            centerGeozone(zone){
                this.closeDrawer()
                let coords = this.zoneCoordinates(zone)

                console.log("cooords: ",coords)

                this.bounds = coords
            },
            centerOrOpenGeozone(zone){
                this.centerGeozone(zone)
            },
            editGeozone(zone, showSave=true){
                if(!this.newMode){
                    // cat geopoly to correct editPolyPoints array useable by save screen
                    let arr=[]
                    zone.geopoly.coordinates[0].forEach((cr) => {
                    arr.push({"lng":cr[0], "lat":cr[1]})
                    });

                    this.editPolyPoints  = arr
                    this.selectedGeoZone = zone
                    this.showSaveGeoZone = showSave
                }
            },
            mutateGeoZone(){
                this.editGeozone(this.selectedGeoZone,false)
                this.editMode = true;
            },
            mapfix(){

            },
            zoneCoordinates(zone){
                // need to                 
                //console.log(zone.geopoly.coordinates)
                return this.geojsonCoordinatesToPoly(zone.geopoly.coordinates)
            },
            geoZoneIsSaved(geoZone){                
                this.editPolyPoints = []
                this.showSaveGeoZone = false
                this.newMode = false
                this.editMode = false
                this.selectedGeoZone=null
                this.loadGeoZones()
            },
            geoZoneIsDeleted(){
                this.$notify('Point of interest is verwijderd',{type: 'success', 'icon': 'checked'})
                this.editPolyPoints = []
                this.showSaveGeoZone = false
                this.newMode = false
                this.editMode = false
                this.selectedGeoZone=null
                this.loadGeoZones()                
            },
            startNewGeoZone(){
                this.newMode = true;
            },
            cancelNewGeoZone(){
                this.newMode = false;
                this.editMode = false;
                this.editPolyPoints = []
            },
            saveNewGeoZone(){
                this.showSaveGeoZone = true
            },
            deleteGeoZone(geoZone){
                this.$store.dispatch(types.DELETE_GEO_ZONE,{data:{id: geoZone.id}}).then(() => {
                    this.$notify(`Geo zone ${geoZone.name} vewijderd`, {type: 'success', icon: 'check'})
                    this.$store.dispatch(types.GEO_ZONES,{})
                    this.deleteDialog = false
                    this.selectedGeoZone = null
                })
            },
            mapClicked(e){                
                if(this.newMode){
                    let latLon = e.latlng
                    this.editPolyPoints.push(e.latlng);

                    console.log(this.editPoints);
                }            
            },
            log(e){
                console.log(e);
            },
            icon(color){                
                //let color = '#e91e63'
        
                let html = `<div class="geozone-pin"                            
                                style="background-color:${color}">                                        
                            </div>`                
                return L.divIcon({
                    iconSize: new L.Point(20, 20),
                    iconAnchor:[10,10],                
                    html
                });
            },
            zonePositionIcon(zone){                                
                let html = `<div class="marker-pin">
                                <div
                                class="inner-pin "
                                style="background-color:#37C6F2;">
                                <i class="fas fa-draw-polygon"></i>
                                </div>  
                            </div>`;

                html = `<div class="geo-marker-pin">
                                <div
                                class="inner-pin "
                                style="background-color:#37C6F2;">
                                <i class="far fa-draw-polygon"></i>
                                </div>  
                            </div>`

                return L.divIcon({
                    iconSize: new L.Point(34, 34),
                    iconAnchor: [17, 34],
                    someData: "test",
                    html
                })
            },        
            determineZoneCenter(zone){                          
                let centre = this.getCentroid(zone.geopoly.coordinates[0])
                return L.latLng(centre[1], centre[0])                                
            },    
            markerDragged(event, index){                
                Vue.set(this.editPolyPoints, index, event.target._latlng)
            },
            loadTypeFilters(){
                let filters={}
                this.geoZoneTypes.forEach((type)=>{
                    filters[type.id] = true;
                })

                this.zoneTypeFilters = filters   
            },
            loadGeoZones(){
                this.$store.dispatch(types.GEO_ZONES,{params:{per_page:200,
                                                              include:`geoZoneType,geoZoneEvent,geoZoneEvent.enterEvent,
                                                                       geoZoneEvent.enterEvent.eventSeverity,geoZoneEvent.enterEvent.eventType,
                                                                       geoZoneEvent.exitEvent,geoZoneEvent.exitEvent.eventSeverity,
                                                                       geoZoneEvent.exitEvent.eventType`                                                              
                                                      }}).then(() => {                    
                    // reload selected geoZone if one is selected
                    if(this.selectedGeoZone){
                        this.geoZones.forEach((zone) =>{                        
                            if(zone.id == this.selectedGeoZone.id)
                                this.selectedGeoZone = zone;
                        })                    
                    }
                })                
            },
            loadGeoZoneTypes(){
                if(this.geoZoneTypes.length==0){
                    this.$store.dispatch(types.GEO_ZONE_TYPES,{}).then(() => {
                        this.loadTypeFilters()
                    })
                }
                else{
                    this.loadTypeFilters()
                }
            },
            closeCustomDialog(){
                this.extraFieldConfigDialog = false
            }                                      
        },        
        created(){
            this.$store.dispatch(types.CLEAR_GEO_ZONES);
            this.mapCenter = this.center(52,6)
        },
        mounted(){                        
            this.useDefaultMap()
            this.loadGeoZones()
            this.loadGeoZoneTypes()            
            
            // needed to make sure zoom is shown in correct location
            let vm = this
            vm.zoom = 9
            Vue.nextTick(function () {
                vm.zoom = 10
            })            
        }
    }
</script> 
<style >
    .geo-marker-pin {
        width: 30px;
        height: 30px;
        background: #37C6F2;
        border-radius: 40px 40px 1px 40px;
        position: relative;
        -webkit-transform: rotate(45deg);
        box-shadow: -2px 2px 6px -1px rgba(0, 0, 0, 0.7) !important;
    } 
    .bottom-drawer{
        border-top:1px solid black;
        border-left:1px solid black;
        border-right:1px solid black;
        position:fixed;
        z-index:300;
        background-color:white;
        height:400px;
        
        bottom:0;
    }

    .hover-top-right{
        position:relative;
        top:112px;
        z-index:200;        
    }

    .zone-type-color-box{        
        height:14px;
        width:14px;
        border:1px solid white;
    }
    .fs-map-container{
        height: calc(100vh);
        overflow-y:hidden;

        z-index: 1;
        width: 100%;
        margin-bottom: -212px;
    }

    .geozone-new-button{

        position: absolute;
        z-index: 1000;
        top:0;
        left:0;
        margin-top: 150px;
    }

    .asset-mode-button{
        margin-top:0px !important;
    }

    .asset-mode-bar{
        
    }

    .geozone-save-button{
        position: absolute;
        z-index: 1000;
        top:0; 
        margin-left: 240px;
        margin-top: 150px;
    }

    .geozone-edit-message{
        position: fixed;
        z-index: 999;
        bottom:0;       
        width: 100%;
        text-align: center;
    }

    .geozone-pin{
        width: 20px;
        height: 20px;
        opacity: .8;
        border-radius: 50%;
    }

    .zone-list-container{        
        position: absolute;
        right: 0;
        width: 350px;
        background-color: #fff;
        z-index: 1000;
        margin-top: 6px;
        height: calc(100% - 200px);
        display:flex;
        overflow-y:auto;
        overflow-x:hidden;
        
    }

    .zone-list-button{
        
        position: absolute;
        margin-top: 150px;
        right: 0;
        top: 0;
        margin-right: 10px;
        z-index: 100;
    }

    .map-type-button{
        position: absolute;        
        left: 0;
        bottom: 0;
        margin-right: 10px;
        z-index: 100;
    }


/* map bottom left corner */
    .manage-geo-zone-container .quick-map-config{
        position: fixed;
        bottom:0; 
        left:0;        
        width: 300px;
        background-color: rgba(0,0,0,0.82);
        z-index: 3;        
        padding-bottom: 20px;
        border-top-right-radius: 10px;  
        padding-top: 16px;
    }

    .manage-geo-zone-container .quick-map-form{
        display: flex;
        flex-direction: column;
        margin-top: 0px !important;
        padding: 0px;
    }

    .manage-geo-zone-container .quick-map-form .v-input{
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        height: 24px !important;
    }

    .manage-geo-zone-container .quick-map-top-buttons{
        position: absolute;
        margin-top: -32px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    .manage-geo-zone-container .mini-button{
        width: 28px !important;
        height: 28px !important;
    }

    .manage-geo-zone-container .quick-map-row{
        padding-top: 2px; 
        padding-bottom:2px; 
        cursor:pointer;
    }

    .manage-geo-zone-container .quick-map-row:hover{
        background-color: #777;
    }

</style>